import { selectors as coreSelectors } from 'app-webtech-core';
import parse from 'date-fns/parse';
import isAfter from 'date-fns/isAfter';
import { WAM_SLUG, WAM_EPISODE_TITLE } from 'app-modules/base/constants';

/**
 * Returns the start of current/coming WAM episode
 * returns null iff there are no WAM episodes in the current timeline
 * returns a Date: start of current/coming WAM episode (note: can be in the past,
 * if we are in the middle of an already started episode).
 */
export const wamEpisodeStartsOn = (state) => {
  const channel = coreSelectors.linearChannels.fetchBySlug(state)(WAM_SLUG);
  let res = null;
  if (channel && channel.timelines) {
    const now = Date.now();
    const timeline = channel.timelines.find(
      (tmln) => tmln.title.includes(WAM_EPISODE_TITLE) && isAfter(tmln.stop, now),
    );
    if (timeline) {
      res = parse(timeline.start);
    }
  }
  return res;
};
